export default __webpack_public_path__ + "5ccd942a8800a68d44b6d3f5431909ec.ttf";